/* eslint-disable @typescript-eslint/no-explicit-any */
import styled from 'styled-components';

export const ContentReviewsWrapper = styled.div`
  width: 100%;
`;

export const StarGroupContainer = styled.span`
  position: relative;
  right: 0px;
  white-space: nowrap;
  text-align: left;
`;

const StarGroup = styled.span<any>`
  font-size: ${props => `${props.size}px;`};

  overflow: hidden;
  display: inline-block;
  vertical-align: bottom;

  &:before {
    content: '\\2605\\2605\\2605\\2605\\2605';
  }

  ${props => (props.percent ? `width: ${props.percent}%;` : ``)};
`;

export const StarGroupOn = styled<any>(StarGroup)`
  color: #feb948 !important;
  left: 0px;
  position: absolute;
`;

export const StarGroupOff = styled<any>(StarGroup)`
  color: #222222 !important;
  left: 0px;
`;

export const ContentYellowBarBase = styled.div`
  width: 30px;
  height: 4px;
  color: #ffffff;
  background-color: #fbb649;
`;

export const ContentReadMoreYellowBar = styled<any>(ContentYellowBarBase)`
  margin-left: auto;
  margin-right: auto;
`;

export const ContentReviewsOverview = styled.div`
  background-color: white;
  padding: 16px 0px;
  text-align: center;
`;

export const ContentReviewsSections = styled.div<any>`
  display: flex;
  flex-flow: column;
  text-align: center;
  margin-left: auto;
  margin-right: auto;

  @media (min-width: ${props => props.theme.breakpoints.values.sm}px) {
    width: 90%;
    display: inline-block;
  }
`;

export const ContentReviewSectionBase = styled.div<any>`
  background-color: ${props => (props.whiteBackground ? '#ffffff' : 'auto')};
  padding: 19px 0px;
  order: 1;
  position: relative;
  vertical-align: top;

  & h3 span {
    display: block;
    height: 18px;
    color: #183558;
    font-family: 'Brandon Text';
    font-size: 24px;
    font-weight: 700;
    line-height: 26px;
    text-transform: uppercase;
    margin-top: 19px;
    padding-bottom: 1em;
  }
  & h3 {
    color: #757989;
    font-family: 'Brandon Text';
    font-size: 22px;
    font-weight: 300;
  }
`;

export const ContentReadMoreOverview = styled<any>(ContentReviewSectionBase)`
  order: 1;

  @media (min-width: ${props => props.theme.breakpoints.values.sm}px) {
    text-align: center;
  }
`;

export const ContentReviewArea = styled<any>(ContentReviewSectionBase)`
  && {
    width: 100%;
    min-width: ${props => props.minWidth};
    margin-top: 2em;
    ${props => (props.isModal ? 'padding: 2em' : '')};
  }

  @media (min-width: ${props => props.theme.breakpoints.values.sm}px) {
    && {
      ${props => (!props.isModal ? 'padding: 1em' : '')};
    }
  }
`;

export const ContentReviewAreaPlaceholder = styled<any>(ContentReviewArea)`
  && {
    min-width: ${props => props.minWidth};
  }
`;

export const ContentReviewStars = styled.div<any>`
  position: relative;

  && {
    order: ${props => props.order};
    text-align: left;
    width: 100%;
  }
`;

const ReviewStarsTextBase = styled.span`
  left: 0px;
  color: #183558;
  font-family: 'Brandon Text';
  font-size: 14px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.35px;
  text-align: left;
  display: inline-block;
  whitespace: nowrap;
`;

export const ReviewStarsText = styled<any>(ReviewStarsTextBase)`
  width: 50%;
`;

export const ReviewsOverviewStarsText = styled<any>(ReviewStarsTextBase)`
  color: #757989;
  font-weight: 400;
`;

const ContentReviewItemHeaderNameDate = styled.div`
  top: 0px;
  position: absolute;
  height: 13px;
  font-family: 'Brandon Text';
  line-height: 18px;
  text-transform: uppercase;
`;

export const ContentReviewCustomerName = styled<any>(
  ContentReviewItemHeaderNameDate
)`
  left: 0px;
  color: #183558;
  font-size: 16px;
  font-weight: 700;

  ${props => (props.isModal ? 'padding-left: 2em' : '')};

  @media (min-width: ${props => props.theme.breakpoints.values.sm}px) {
    font-size: 20px;
    padding-left: 0.8em;
  }
`;

export const ContentReviewDate = styled<any>(ContentReviewItemHeaderNameDate)`
  right: 0px;
  color: #757989;
  font-size: 14px;
  font-weight: 200;

  ${props => (props.isModal ? 'padding-right: 2em' : '')};

  @media (min-width: ${props => props.theme.breakpoints.values.sm}px) {
    padding-right: 1em;
  }
`;

export const ContentReviewCustomerVehicleLocationWrapper = styled.div`
  position: relative;
  margin-top: 0.25em;
  margin-bottom: 2em;
`;

const ContentReviewItemHeaderVehicleLocation = styled.div`
  top: 0px;
  position: absolute;
  height: 13px;
  font-family: 'Brandon Text';
  line-height: 18px;
`;

export const ContentReviewCustomerVehicle = styled<any>(
  ContentReviewItemHeaderVehicleLocation
)`
  right: 0px;
  color: #757989;
  font-size: 12px;
  font-weight: 200;
`;

export const ContentReviewCustomerLocation = styled<any>(
  ContentReviewItemHeaderVehicleLocation
)`
  left: 0px;
  color: #757989;
  font-size: 12px;
  font-weight: 200;
`;

export const ContentReviewBody = styled.div<any>`
  color: #757989;
  font-family: 'Brandon Text';
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.35px;
  text-align: left;
  max-height: ${props => (props.restrictHeight ? '6em' : 'auto')};
  overflow: hidden;
  margin-top: 1em;
  position: relative;

  &:before {
    cursor: default;
    background-image: ${props =>
      props.useFade ? 'linear-gradient(180deg,hsla(0,0%,100%,0),#ffffff)' : ''};

    content: '';
    height: 3em;
    left: 0;
    position: absolute;
    width: 100%;
    top: 3em;
  }

  @media (min-width: ${props => props.theme.breakpoints.values.sm}px) {
    min-height: ${props => (props.restrictHeight ? '6em' : 'auto')};
  }
`;

export const ContentReviewBodyEllipsis = styled.div`
  color: #757989;
  font-family: 'Brandon Text';
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.35px;
  text-align: left;
`;

export const ContentReviewReadMoreButton = styled.div<any>`
  color: #00aed9;
  font-family: 'Brandon Text';
  font-size: 14px;
  font-weight: 700;
  text-transform: uppercase;
  text-align: left;
  margin-top: 1em;
  position: relative;
  cursor: pointer;

  &:after {
    background-image: ${props =>
      props.useFade ? 'linear-gradient(180deg,hsla(0,0%,100%,0),#ffffff)' : ''};
    bottom: 28px;
    content: '';
    height: 3em;
    left: 0;
    position: absolute;
    width: 100%;
  }
`;

export const ContentReviewSectionSeparatorBase = styled.div`
  height: 1px;
  background-color: #d9dde9;
  width: 100%;
  margin-top: 1em;
  margin-bottom: 1em;
`;

export const ContentReviewSectionSeparator = styled<any>(
  ContentReviewSectionSeparatorBase
)`
  order: ${props => props.order};
`;

export const CarouselItem = styled.div<any>`
  outline: 0px;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  overflow: hidden;
  background: ${props => props.theme.carvana.white.primary};
  width: ${props => props.itemWidth - props.margin * 2}px;
  background: #f4f8fa;
  border-radius: 3px;
  position: relative;
  margin: ${props => `0 ${props.margin}px`};
  background-color: #ffffff;
  padding: 1em;

  @media (min-width: ${props => props.theme.breakpoints.values.sm}px) {
    flex-flow: row nowrap;
    align-items: flex-start;
  }
`;

export const CarouselWrapper = styled.div<any>`
  display: flex;
  flex-direction: column;
  align-items: center;
  order: 2;
  .slider {
    padding-bottom: 40px;
  }
  .slider-control-centerleft {
    bottom: 3% !important;
    left: 5% !important;
    top: auto !important;
  }
  .slider-control-centerright {
    bottom: 3% !important;
    right: 15% !important;
    top: auto !important;
  }

  .slider-control-bottomcenter {
    .paging-item {
      span {
        background: ${props => props.theme.carvana.gray.medium} !important;
      }
      &.active {
        span {
          background: ${props => props.theme.carvana.blue.primary} !important;
        }
      }
    }
  }

  & .reviews-carousel-container {
    width: 90%;
    margin: 0 auto;
    padding-bottom: 90px;
  }

  & .react-multi-carousel-list {
    display: flex;
    align-items: center;
    overflow: hidden;
    position: relative;
  }
  & .react-multi-carousel-track {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: row;
    position: relative;
    transform-style: preserve-3d;
    backface-visibility: hidden;
    will-change: transform, transition;
  }
  & .react-multiple-carousel__arrow {
    position: absolute;
    bottom: 0;
    outline: 0;
    transition: all 0.5s;
    border-radius: 35px;
    border: 0;
    background: rgb(255, 255, 255);
    min-width: 43px;
    min-height: 43px;
    opacity: 1;
    cursor: pointer;
    box-shadow: rgba(25, 41, 61, 0.15) 0px 14px 23px 1px;
    transition: transform 200ms ease, color 200ms ease;
    transform: scale(0.9) translateY(-50%);
  }
  & .react-multiple-carousel__arrow:hover {
    transform: scale(1) translateY(-48%);
  }
  & .react-multiple-carousel__arrow::before {
    display: block;
    color: rgb(0, 174, 217);
    text-align: center;
    z-index: 2;
    position: relative;
  }
  & .react-multiple-carousel__arrow--left {
    left: calc(4% + 1px);
  }
  & .react-multiple-carousel__arrow--left::before {
    top: 3px;
    left: 0px;
    content: url(data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNiAxMCIgaGVpZ2h0PSIxNyIgd2lkdGg9IjE3IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxnIGZpbGw9IiMwMGFlZDkiPjxwYXRoIGQ9Ik01LjE5IDEwYS44LjggMCAwIDEtLjU1LS4yM0wuMjYgNS40OEEuOS45IDAgMCAxIDAgNC44NGEuOTIuOTIgMCAwIDEgLjI4LS42M2w0LjM4LTRBLjc3Ljc3IDAgMCAxIDUuOC4zYS44Ny44NyAwIDAgMS0uMDggMS4yTDIgNC44OGwzLjc0IDMuNjRhLjg4Ljg4IDAgMCAxIDAgMS4yMS43Ni43NiAwIDAgMS0uNTkuMjciPjwvcGF0aD48L2c+PC9zdmc+);
  }
  & .react-multiple-carousel__arrow--right {
    right: calc(4% + 1px);
  }
  & .react-multiple-carousel__arrow--right::before {
    top: 3px;
    right: 0px;
    content: url(data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNiAxMCIgaGVpZ2h0PSIxNyIgd2lkdGg9IjE3IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxnIGZpbGw9IiMwMGFlZDkiPjxwYXRoIGQ9Ik0uODEgMTBhLjc0Ljc0IDAgMCAwIC41NS0uMjNsNC4zOC00LjI5QS44OS44OSAwIDAgMCA2IDQuODRhLjg0Ljg0IDAgMCAwLS4yOC0uNjNsLTQuMzgtNEEuNzcuNzcgMCAwIDAgLjIuM2EuODguODggMCAwIDAgLjA4IDEuMkw0IDQuODguMjYgOC41MmEuODguODggMCAwIDAgMCAxLjIxLjc4Ljc4IDAgMCAwIC41NS4yNyI+PC9wYXRoPjwvZz48L3N2Zz4=);
  }
  & .react-multi-carousel-dot-list {
    position: absolute;
    bottom: 28px;
    display: flex;
    left: 0;
    right: 0;
    justify-content: center;
    margin: auto;
    padding: 0;
    margin-left: 25%;
    margin-right: 25%;
    list-style: none;
    text-align: center;
  }
  & .react-multi-carousel-dot button {
    display: inline-block;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    opacity: 1;
    padding: 0;
    box-shadow: none;
    transition: background 0.5s;
    border-width: 0px;
    background: rgb(170, 177, 199);
    margin: 0 7px;
    outline: 0;
    cursor: pointer;
  }
  & .react-multi-carousel-dot--active button {
    background: rgb(0, 174, 217);
  }

  & .react-multi-carousel-item {
    transform-style: preserve-3d;
    backface-visibility: hidden;
  }
  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    & .react-multi-carousel-item {
      flex-shrink: 0 !important;
    }
    & .react-multi-carousel-track {
      overflow: visible !important;
    }
  }

  @media (min-width: ${props => props.theme.breakpoints.values.lg}px) {
    padding-bottom: 0;
    .slider-control-centerleft {
      left: 5% !important;
    }
    .slider-control-centerright {
      right: 10% !important;
    }
  }
`;
export const SeeAllReviewsLink = styled.a`
  color: #00aed9;
  font-family: 'Brandon Text';
  font-size: 14px;
  font-weight: 700;
  text-transform: uppercase;
  text-align: left;
  margin-top: 1em;
  position: relative;
  cursor: pointer;
  &:hover {
    text-decoration: none;
    color: #00aed9;
  }
`;
export const ReviewsOverviewArea = styled<any>(ContentReviewSectionBase)`
  order: 1;
  padding: 0px;

  flex-direction: row;
  align-items: baseline;
  display: flex;
  margin-left: auto;
  margin-right: auto;
  flex-wrap: wrap;
  justify-content: center;
`;

export const ReviewsOverviewAreaStars = styled.div`
  display: inline-block;
  text-align: left;
  margin-right: 1em;
`;

export const ReviewsOverviewTitle = styled.span<any>`
  color: #183558;
  font-family: 'Brandon Text';
  font-size: 16px;
  font-weight: 700;
  white-space: nowrap;
  width: 100%;

  @media (min-width: ${props => props.theme.breakpoints.values.sm}px) {
    width: auto;
  }
`;
